export default "__VITE_ASSET__nPHov490__"